module.exports = "<h2 class=\"dash-header\" hide-xs>\n  <span>Home</span>\n</h2>\n<span flex>\n"